import { call, put, select, all, takeLatest } from 'redux-saga/effects';
import { genreActionTypes as types } from 'src/redux/actions/genreActions';
import { ref as dbRef, get, set, push, update, remove } from "firebase/database";
import { ref as stoRef, uploadBytes, getDownloadURL, listAll } from "firebase/storage";
import notification from 'src/utils/notification';
import { removeEmptyFields, toNullPropsObj } from 'src/utils/helpers';
import adminSelectors from 'src/redux/selectors/adminSelectors';
import { database, storage } from 'src/firebase';

function* fetchGenres({ payload, callback }) {
  try {
    const genresDbRef = dbRef(database, 'genres');
    const data = yield get(genresDbRef);
    if (!data.exists()) {
      throw new Error('No data!');
    }

    yield put({ type: types.FETCH_GENRES_SUCCESS, data: data.val() });
    notification.close();
    callback?.();
  } catch (error) {
    yield put({ type: types.FETCH_GENRES_FAILURE, error });
    console.error(error);
    notification.showError(error.message);
  }
}

function* addGenre({ payload, callback }) {
  try {
    const data = removeEmptyFields(payload);
    const admin = yield select(adminSelectors.admin);
    const rootDbRef = dbRef(database);
    const { key } = yield push(rootDbRef);
    const genresDbRef = dbRef(database, `genres/${key}`);
    yield set(genresDbRef, {
      ...data,
      id: key,
      createdAt: Date.now(),
      createdBy: admin.email,
    });

    yield put({ type: types.ADD_GENRE_SUCCESS });
    notification.close();
    notification.showSuccess('Success', 3);
    callback?.();
  } catch (error) {
    yield put({ type: types.ADD_GENRE_FAILURE, error });
    console.error(error);
    notification.showError(error.message);
  }
}

function* editGenre({ payload, callback }) {
  try {
    const { name, color, genreId } = payload;
    const data = removeEmptyFields({ name, color });
    const admin = yield select(adminSelectors.admin);
    const genresDbRef = dbRef(database, `genres/${genreId}`);
    yield update(genresDbRef, {
      ...data,
      updatedAt: Date.now(),
      updatedBy: admin.email,
    });

    yield put({ type: types.EDIT_GENRE_SUCCESS });
    notification.close();
    notification.showSuccess('Success', 3);
    callback?.();
  } catch (error) {
    yield put({ type: types.EDIT_GENRE_FAILURE, error });
    console.error(error);
    notification.showError(error.message);
  }
}

function* deleteGenres({ payload, callback }) {
  try {
    const data = toNullPropsObj(payload);
    const genresDbRef = dbRef(database, 'genres');
    yield update(genresDbRef, data);

    yield put({ type: types.DELETE_GENRES_SUCCESS });
    notification.close();
    notification.showSuccess('Success', 3);
    callback?.();
  } catch (error) {
    yield put({ type: types.DELETE_GENRES_FAILURE, error });
    console.error(error);
    notification.showError(error.message);
  }
}

export default function* genreSaga() {
  yield all([
    takeLatest(types.FETCH_GENRES_REQUEST, fetchGenres),
    takeLatest(types.ADD_GENRE_REQUEST, addGenre),
    takeLatest(types.EDIT_GENRE_REQUEST, editGenre),
    takeLatest(types.DELETE_GENRES_REQUEST, deleteGenres),
  ])
}
